import React from 'react';
import Image from './img/consumo_back_crop.jpg';
import './home.css';

const HeroHeader = () => (
  <section id="home" className="u-bg-overlay g-pos-rel g-theme-bg-blue-dark-v1-opacity-0_8--after">
    <div className="js-carousel">
      <div
        className="js-slide g-bg-img-hero g-height-100vh"
        style={{ backgroundImage: `url(${Image})` }}
      />
    </div>

    <div className="u-bg-overlay__inner g-absolute-centered w-100">
      <div className="container text-center g-max-width-750">
        <div className="text-uppercase u-heading-v2-4--bottom u-promo-title g-brd-primary">
          <h3 className="h3 g-letter-spacing-7 g-font-size-12 g-font-weight-400 g-color-white g-mb-25">
            Calculadora de Consumo Solar-Power
          </h3>
          <h2 className="u-heading-v2__title g-line-height-1 g-letter-spacing-3 g-font-size-75 g-color-white mb-0">
            Consumo
          </h2>
        </div>
        <div>
          <span className="u-icon-v1" style={{ color: 'white', fontSize: '2.5rem' }}>
            <i className="icon-arrow-down" />
          </span>
        </div>
      </div>
    </div>
  </section>
);

export default HeroHeader;



// WEBPACK FOOTER //
// ./src/components/Home/HeroHeader/index.js